export const routes = {
  callback: "/callback",

  dashboard: "/dashboard",

  clients: "/clients",
  client: (clientId: string) => `/clients/${encodeURIComponent(clientId)}`,
  createPerson: "/clients/new/person",
  createOrganisation: "/clients/new/organisation",

  quotes: "/quotes",
  combinedQuoteBuilder: "/quotes/combined",
  combinedQuoteBuilderWithClient: (clientId: string) =>
    `/quotes/combined?clientId=${encodeURIComponent(clientId)}`,
  combinedQuoteBuilderWithId: (quoteId: string) => `/quotes/combined/${encodeURIComponent(quoteId)}`,
  quoteSummary: (quoteId: string) => `/quotes/${encodeURIComponent(quoteId)}`,

  assets: "/assets",
  asset: (assetId: string) => `/assets/${encodeURIComponent(assetId)}`,

  renewals: "/renewals",
  renewal: (renewalId: string) => `/renewals/${encodeURIComponent(renewalId)}`,
  renewalAmendment: (renewalId: string) => `/renewals/${encodeURIComponent(renewalId)}/amendment`,

  policies: "/policies",
  policy: (policyId: string) => `/policies/${encodeURIComponent(policyId)}`,
  policyHistory: (policyId: string) => `/policies/${encodeURIComponent(policyId)}/history`,

  invoices: "/invoices",
  reconciliationHistory: "/invoices/reconciliation-history",
  invoice: (invoiceId: string) => `/invoices/${encodeURIComponent(invoiceId)}`,

  reports: "/reports",
  businessWrittenReport: "/reports/business-written",
  debtorsReport: "/reports/debtors",
  cashCreditsReport: "/reports/cash-credits",
  commissionsReport: "/reports/commissions",
  policyRenewalReport: "/reports/policy-renewal",
  adviserPerformanceReport: "/reports/adviser-performance",
  bordeauxReport: "/reports/bordeaux",

  users: "/users",
  user: (userId: string) => `/users/${encodeURIComponent(userId)}`,

  advisers: "/advisers",
  adviser: (adviserId: string) => `/advisers/${encodeURIComponent(adviserId)}`,

  businessAdmins: "/business-admins",
  businessAdmin: (businessAdminId: string) =>
    `/business-admins/${encodeURIComponent(businessAdminId)}`,

  faps: "/faps",
  fap: (fapId: string) => `/faps/${encodeURIComponent(fapId)}`,
  createFap: "/faps/new",
  editFap: (fapId: string) => `/faps/${encodeURIComponent(fapId)}/edit`,

  auditLog: "/audit-log",
  notifications: "/notifications",
  health: "/health",
  appConfig: "/app-config",
  eofferDemo: "/eoffer-demo",
  eoffer: (eofferId: string) => `/eoffer/${encodeURIComponent(eofferId)}`,
  eofferReturn: (eofferId: string) => `/eoffer/${encodeURIComponent(eofferId)}/return`,

  mtaWorkflow: (policyId?: string, mtaId?: string) => {
    if (policyId && mtaId) {
      return `/mta/${encodeURIComponent(policyId)}/${encodeURIComponent(mtaId)}`;
    }
    if (policyId) {
      return `/mta/${encodeURIComponent(policyId)}`;
    }
    return "/mta";
  },
};


